import {
    mobile,
    backend,
    creator,
    web,
    javascript,
    typescript,
    html,
    css,
    reactjs,
    redux,
    tailwind,
    nodejs,
    mongodb,
    git,
    figma,
    docker,
    meta,
    starbucks,
    tesla,
    shopify,
    carrent,
    jobit,
    tripguide,
    threejs,
    girlscript,
    renuSharma,
    snacmate,
  } from "../assets";
  import { projects } from "./projectsData";
  
  export const navLinks = [
    {
      id: "about",
      title: "About",
    },
    {
      id: "work",
      title: "Work",
    },
    {
      id: "contact",
      title: "Contact",
    },
  ];
  
  const services = [
    {
      title: "Web Developer",
      icon: web,
    },
    {
      title: "React Native Developer",
      icon: mobile,
    },
    {
      title: "Backend Developer",
      icon: backend,
    },
    {
      title: "Content Creator",
      icon: creator,
    },
  ];
  
  const technologies = [
    {
      name: "HTML 5",
      icon: html,
    },
    {
      name: "CSS 3",
      icon: css,
    },
    {
      name: "JavaScript",
      icon: javascript,
    },
    {
      name: "TypeScript",
      icon: typescript,
    },
    {
      name: "React JS",
      icon: reactjs,
    },
    {
      name: "Redux Toolkit",
      icon: redux,
    },
    {
      name: "Tailwind CSS",
      icon: tailwind,
    },
    {
      name: "Node JS",
      icon: nodejs,
    },
    {
      name: "MongoDB",
      icon: mongodb,
    },
    {
      name: "Three JS",
      icon: threejs,
    },
    {
      name: "git",
      icon: git,
    },
    {
      name: "figma",
      icon: figma,
    },
    {
      name: "docker",
      icon: docker,
    },
  ];
  
  const experiences = [
    {
      title: "Full Stack Web Development Intern",
      company_name: "SnacMate",
      icon: snacmate,
      iconBg: "#E6DEDD",
      date: "Oct 2025 - Nov 2025",
      type: "Work",
      points: [
        "Developed responsive web interfaces using React and Tailwind CSS for food delivery platform.",
        "Implemented backend API integrations for order management and user authentication.",
        "Optimized database queries and improved application loading performance by 25%.",
        "Collaborated with design team to enhance user experience and mobile responsiveness.",
      ],
    },
    {
      title: "Full Stack Web Development Intern",
      company_name: "RS Foundation",
      icon: renuSharma,
      iconBg: "#E6DEDD",
      date: "March 2025 - June 2025",
      type: "Work",
      points: [
        "Developed and deployed scalable MERN-based applications with optimized REST APIs and dynamic frontend interfaces.",
        "Improved application performance through API optimization and frontend rendering enhancements.",
        "Collaborated with cross-functional teams to implement UI/UX improvements and feature enhancements.",
        "Managed Git workflows including version control, code reviews, and deployment pipelines.",
      ],
    },
    {
      title: "Mentor",
      company_name: "GirlScript Summer of Code",
      icon: girlscript,
      iconBg: "#E6DEDD",
      date: "Jul 2025 - Oct 2025",
      type: "Work",
      points: [
        "Mentored 50+ contributors in Full Stack and Generative AI development.",
        "Conducted code reviews and guided teams to deliver scalable deployable applications.",
        "Promoted best practices in collaborative software engineering.",
      ],
    },
    {
      title: "Open Source Contributor",
      company_name: "GirlScript Summer of Code",
      icon: girlscript,
      iconBg: "#E6DEDD",
      date: "Oct 2024",
      type: "Work",
      points: [
        "Enhanced UI/UX components using Tailwind CSS and GSAP across open-source modules.",
        "Improved mobile responsiveness by over 30% through layout optimizations.",
        "Collaborated with 50+ contributors while reviewing pull requests and resolving merge conflicts.",
      ],
    },
    {
      title: "Bachelor of Engineering",
      company_name: "Army Institute of Technology",
      icon: meta,
      iconBg: "#E6DEDD",
      date: "2024 - 2028",
      type: "Education",
      points: [
        "Active member of AI research groups, technical clubs, and hackathon teams.",
        "Participated in national-level technical competitions and research conferences.",
        "Winner of GDG Nirman 3.0 Hackathon and Second Place in Fresher's Season of Code.",
        "Selected participant in ASCENT'25 Research Conference at NIT Warangal.",
      ],
    },
    {
      title: "Senior Secondary Education (PCM)",
      company_name: "Matrix Sikar",
      icon: meta,
      iconBg: "#E6DEDD",
      date: "2022 - 2024",
      type: "Education",
      points: [
        "Prepared for competitive engineering entrance examinations including JEE Mains and Advanced.",
        "JEE Advanced qualified with strong foundation in Physics, Chemistry, and Mathematics.",
        "Participated in academic competitions and science olympiads at state level.",
      ],
    },
  ];
  
  export { services, technologies, experiences, projects };